import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from './queryKeys';

const getAttachedFile = async ({ docId, fileName }) => {
  return await request.get(
    '/Docs/attachment',
    { docId, fileName },
    'При получении документа произошла ошибка'
  );
};

const useAttachedFileQuery = ({ docId, fileName }, options) =>
  useQuery(
    queryKeys.attachedFile({ docId, fileName }),
    () => getAttachedFile({ docId, fileName }),
    options
  );

export default useAttachedFileQuery;
